import React from 'react';
import { IChildrenProps } from '../../../models/utilTypes';
import SiteNavDropdown from '../SiteNavDropdown';
import SportSubLinksList from './SportSubLinksList';

interface ISingleSportDropdownProps extends IChildrenProps {
  subItems: any[];
}

const SingleSportDropdown: React.FC<ISingleSportDropdownProps> = ({
  subItems
}) => (
  <SiteNavDropdown>
    <SportSubLinksList subItems={subItems} />
  </SiteNavDropdown>
);

export default SingleSportDropdown;
